"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 200 200",
  xmlSpace: "preserve",
  children: [80, 60, 40, 20].map((value, index) => {
    const radius = 40 + index * 15;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference * 0.25;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      cx: "100",
      cy: "100",
      r: radius,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "10",
      strokeDasharray: `${circumference - offset} ${circumference}`,
      strokeDashoffset: 0,
      transform: "rotate(-90 100 100)"
    }, index);
  })
}));